import * as React from 'react';
import * as Redux from 'redux';
import { IAutocompleteResults, IHit } from '../../DTO/search';

interface IProps {
    searchTerm: string;
    autocompleteResults: IAutocompleteResults;

    onMouseLeave: () => void;
    onResultActive: (index: number) => void;
    onResultClick: (query: string) => void;
}

/// <summary>
/// Creates and renders a collection autocomplete items
/// </summary>
export class Autocomplete extends React.Component<IProps, any> {

    render() {
        return (
            <div className="adage-search-autocomplete autocomplete-on">
                <ul className="adage-search-autocomplete-list">
                    {this.props.autocompleteResults.hits.map(this.renderAutocompleteHit)}
                </ul>
            </div>
        );
    }

    renderAutocompleteHit = (hit: IHit, index: number) => {
        const onResultActive = () => this.props.onResultActive(index);
        const onResultClick = () => this.props.onResultClick(hit.query);

        return (
            <AutocompleteResult
                id={index}
                key={index}
                query={hit.query}
                searchTerm={this.props.searchTerm}
                isActive={this.props.autocompleteResults.activeHit === index}
                onResultActive={onResultActive}
                onResultClick={onResultClick}
                onMouseLeave={this.props.onMouseLeave}
            />
        );
    }
}


export interface IAutocompleteResultProps {
    id: number;
    query: string;
    searchTerm: string;
    isActive: boolean;

    onResultActive: () => void;
    onResultClick: () => void;
    onMouseLeave: () => void;
}

/// <summary>
/// Renders individual autocomplete items
/// </summary>
export class AutocompleteResult extends React.Component<IAutocompleteResultProps, any> {

    get classes() {
        return this.props.isActive ? 'highlighted' : '';
    }

    get highlightedAutoComplete() {
        // Want to escape all '\' characters for the Regex.  Also what to trim spaces and make it lower case for consistency
        var highlightedTerm = this.props.searchTerm
            .replace('\\', '\\\\')
            .replace('(', '\\(')
            .replace(')', '\\)')
            .trim()
            .toLowerCase();
        return this.props.query.replace(new RegExp('(' + highlightedTerm + ')'), '<strong>$1</strong>');
    }

    render() {
        return (
            <li
                className={`adage-search-autocomplete-list-item ${this.classes}`}
                data-value={(this.props.id + 1)}
                onMouseEnter={this.props.onResultActive}
                onMouseLeave={this.props.onMouseLeave}
                onClick={this.props.onResultClick}>

                <span dangerouslySetInnerHTML={{ __html: this.highlightedAutoComplete }} />
            </li>
        );
    }
}